import React, { useContext, useState, useEffect } from 'react'
import { Icon, Menu,  Statistic, /* Loader, */ Popup} from 'semantic-ui-react'
import _ from 'lodash'
import { GetReservationTotals } from '../../api/services/pms'
import { onWarning, onError } from '../../components/shared/messages'
import PropTypes from 'prop-types'
import { Currencies } from '../../components/shared/currencies'
import { GroupReservationContext } from './context'
import { useTextResources } from '../../language'

const GroupTotals = ({HotelID}) => {
    const { state } = useContext(GroupReservationContext)
    const [total, setTotal] = useState(0)
    const [balance, setBalance] = useState(0)
    const [currency, setCurrency] = useState(0)
    const text = useTextResources()
        
    useEffect(()=>{
        (async ()=>{
            try {                                
                const reservations = state.ReservationGroup.ReservationGroupReservations

                const spec = {                   
                    TargetCurrencyId: 2   
                }; 

                const reservationIdsSpec =_.reduce(reservations, (result, reservation, index)=>{
                    if (reservation.Reservation && reservation.Reservation.Id) {
                        result[`ReservationIDs[${index}]`] = reservation.Reservation.Id
                    }
                    return result
                }, {
                    HotelID: HotelID});

                const totals = await GetReservationTotals({...reservationIdsSpec,...spec}) 
            
                if (totals && totals.length) {
                    setTotal(_.sumBy(totals, t=>t.TotalAmountDebitAfterTax) || 0)
                    setBalance(_.sumBy(totals, t=>t.TotalAmountDebitAfterTax + t. TotalAmountCreditAfterTax) || 0)
                    setCurrency(totals[0].CurrencyID)
                }
            } catch (error) {
                error.error.status === 400?onWarning(error):onError(error)
            }
        })()
    }, [state])

    return (
        <React.Fragment>
            <Menu.Item header fitted='vertically'>
                <Icon size="huge" className="icon-wallet2"/>
                <Statistic size="tiny">
                    <Statistic.Value>{/* <Loader active={loading} size="mini"/> */}{total.toFixed(2)}{Currencies[currency].symbol}</Statistic.Value>
                    <Statistic.Label>{text('PriceAfterTax')} <Popup position="top right" trigger={ <Icon name="info" circular size="tiny"/> } content="Displays total group price including all folios after tax"/>
                    </Statistic.Label>
                </Statistic>
            </Menu.Item>
            <Menu.Item header fitted='vertically'>
                <Icon size="huge" className="icon-money-bag" />
                <Statistic size="tiny" color="red">
                    <Statistic.Value>{/* <Loader active={loading} size="mini"/> */}{balance.toFixed(2)}{Currencies[currency].symbol}</Statistic.Value>
                    <Statistic.Label>{text('Balance')} <Popup position="top right" trigger={ <Icon name="info" circular size="tiny"/> } content="Displays rest group payment including all folios after tax"/>
                    </Statistic.Label>
                </Statistic>
            </Menu.Item>
        </React.Fragment>
    )
}

GroupTotals.propTypes = {
    HotelID: PropTypes.any
}

export default GroupTotals